define('native/NativeNotifications',['knockout', 'jquery'], function (ko, $) {

    return function (session, gameLauncher, nativeLayerMessenger, messageChannels) {

        var activeNotificationContent = ko.pureComputed(function () {

            var activeNotification = session.player().notifications.pendingNotifications()[0];

            if (!activeNotification) {

                return;
            }

            return {
                id: activeNotification.id,
                title: activeNotification.notification.title(),
                message: $(activeNotification.notification.message()).text().replace(/\\n|\n/g, ' ').trim(),
                icon: activeNotification.notification.imageUrl()
            };
        });

        activeNotificationContent.subscribe(function (notification) {

            // If we are playing a game then send notifications to native layer
            if (gameLauncher.hasActiveGameRunner()) {
                nativeLayerMessenger.sendMessage(messageChannels.NOTIFICATION_ADDED, notification);
            }
        });
    };
});

